import type { ExpeditionLocality } from '@app/pages/expedition/create/types.ts';

/**
 * Handling units of the shipment per manipulation unit (cargo template code), summed over every order
 * loaded anywhere on the route. The same count the backend prices a CONTRACTED distribution by.
 */
export const unitsByMuFromLocations = (locations: Pick<ExpeditionLocality, 'orders'>[]): Record<string, number> => {
  const units: Record<string, number> = {};
  (locations ?? [])
    .flatMap(loc => loc.orders ?? [])
    .filter(order => order != null)
    .flatMap(order => order.items ?? [])
    .forEach(item => {
      if (!item?.cargoTemplateCode) return;
      units[item.cargoTemplateCode] = (units[item.cargoTemplateCode] ?? 0) + (item.amount ?? 0);
    });
  return units;
};

/** The manipulation units that actually occur (a positive count) — what every contracted carrier has to price. */
export const muCodesOf = (unitsByMu: Record<string, number>): string[] => Object.keys(unitsByMu ?? {}).filter(code => (unitsByMu[code] ?? 0) > 0);
